import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "../components/Layout";
import countryCodes from "../data/countryCodes"; // Import des codes pays

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost/securecontrol-backend";

const UserCreate = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    nom: "",
    prenom: "",
    email: "",
    phone: "", // Seulement les chiffres
    profile: "",
    matricule_user: "",
    send_email: true
  });

  const [societeForm, setSocieteForm] = useState({
    nom_societe: "",
    address_societe: "",
    tel_societe: "", // Seulement les chiffres
    email_societe: "",
    nif_societe: "",
    rccm_societe: "",
    code_postal_societe: ""
  });

  const [files, setFiles] = useState({
    nif: null,
    rccm: null
  });

  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [passwordCopie, setPasswordCopie] = useState(false);
  const [passwordMasque, setPasswordMasque] = useState(true);
  const [loading, setLoading] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(null);
  const [currentSocieteId, setCurrentSocieteId] = useState(null);

  // États pour les sélecteurs d'indicatif
  const [showCountryListPersonal, setShowCountryListPersonal] = useState(false);
  const [showCountryListSociete, setShowCountryListSociete] = useState(false);
  const [selectedCountryPersonal, setSelectedCountryPersonal] = useState(
    countryCodes?.find(c => c.code === "+227") || countryCodes?.[0] || { 
      code: "+227", 
      name: "Niger", 
      flag: "🇳🇪",
      phoneLength: 8,
      pattern: "^\\+227\\d{8}$"
    }
  );
  const [selectedCountrySociete, setSelectedCountrySociete] = useState(
    countryCodes?.find(c => c.code === "+227") || countryCodes?.[0] || { 
      code: "+227", 
      name: "Niger", 
      flag: "🇳🇪",
      phoneLength: 8,
      pattern: "^\\+227\\d{8}$"
    }
  );
  const [searchCountryPersonal, setSearchCountryPersonal] = useState("");
  const [searchCountrySociete, setSearchCountrySociete] = useState("");
  
  // Références pour fermer les dropdowns
  const countryListRefPersonal = useRef(null);
  const countryListRefSociete = useRef(null);

  // Fermer les dropdowns en cliquant à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (countryListRefPersonal.current && !countryListRefPersonal.current.contains(event.target)) {
        setShowCountryListPersonal(false);
      }
      if (countryListRefSociete.current && !countryListRefSociete.current.contains(event.target)) {
        setShowCountryListSociete(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setCurrentProfile(String(user.profile));
        setCurrentSocieteId(user.societe_id || null);
      } catch (e) {
        console.error("Erreur parse user:", e);
      }
    }
  }, []);

  useEffect(() => {
    if (currentProfile === "1") {
      if (form.profile === "1") {
        setForm(prev => ({ ...prev, matricule_user: "" }));
      }
      
      if (form.profile !== "3") {
        setSocieteForm({
          nom_societe: "",
          address_societe: "",
          tel_societe: "",
          email_societe: "",
          nif_societe: "",
          rccm_societe: "",
          code_postal_societe: ""
        });
        setFiles({ nif: null, rccm: null });
      }
    }
  }, [form.profile, currentProfile]);

  // Fonction pour extraire les chiffres
  const extractPhoneDigits = (phoneValue) => {
    if (!phoneValue) return "";
    return phoneValue.replace(/\D/g, "");
  };

  // Fonction pour formater avec indicatif
  const formatFullPhoneNumber = (phoneDigits, countryCode = "+227") => {
    if (!phoneDigits) return "";
    return countryCode + phoneDigits;
  };

  // Fonction pour générer exemple
  const generatePhoneExample = (phoneLength) => {
    if (!phoneLength) return "";
    let example = "";
    for (let i = 0; i < phoneLength; i++) {
      example += (i % 10).toString();
    }
    return example;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    // Pour les champs téléphone, n'accepter que les chiffres
    if (name === "phone") {
      // Déterminer la longueur max selon le pays
      const maxLength = selectedCountryPersonal?.phoneLength || 15;
      
      // Garder seulement les chiffres
      const digitsOnly = value.replace(/\D/g, "");
      // Limiter selon la longueur du pays
      const limitedDigits = digitsOnly.substring(0, maxLength);
      
      setForm(prev => ({ 
        ...prev, 
        [name]: limitedDigits 
      }));
    } else {
      setForm(prev => ({ 
        ...prev, 
        [name]: type === "checkbox" ? checked : value 
      }));
    }
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const handleSocieteChange = (e) => {
    const { name, value } = e.target;
    
    // Pour le téléphone société, n'accepter que les chiffres
    if (name === "tel_societe") {
      const maxLength = selectedCountrySociete?.phoneLength || 15;
      const digitsOnly = value.replace(/\D/g, "");
      const limitedDigits = digitsOnly.substring(0, maxLength);
      
      setSocieteForm(prev => ({ ...prev, [name]: limitedDigits }));
    } else {
      setSocieteForm(prev => ({ ...prev, [name]: value }));
    }
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    setFiles(prev => ({ ...prev, [name]: file }));
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const e = {};
    
    // Lettres (accentuées), espaces, tirets et apostrophes uniquement — pas de
    // chiffres ni de caractères spéciaux dans un nom/prénom.
    const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/;
    if (!form.nom.trim()) {
      e.nom = "Le nom est requis.";
    } else if (!nameRegex.test(form.nom.trim())) {
      e.nom = "Le nom ne doit contenir que des lettres.";
    }
    if (!form.prenom.trim()) {
      e.prenom = "Le prénom est requis.";
    } else if (!nameRegex.test(form.prenom.trim())) {
      e.prenom = "Le prénom ne doit contenir que des lettres.";
    }
    
    if (!form.email.trim()) {
      e.email = "L'email est requis.";
    } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(form.email)) {
        e.email = "Format d'email invalide. Exemple : prenom.nom@domaine.com";
      }
    }
    
    if (!form.profile) e.profile = "Le profil est requis.";
    
    // Validation téléphone personnel - DYNAMIQUE PAR PAYS
    const phoneDigits = extractPhoneDigits(form.phone);
    const phoneFullNumber = formatFullPhoneNumber(phoneDigits, selectedCountryPersonal?.code || "+227");
    const expectedLengthPersonal = selectedCountryPersonal?.phoneLength;
    
    if (!form.phone.trim()) {
      e.phone = "Le téléphone est requis.";
    } else if (!/^\d+$/.test(phoneDigits)) {
      e.phone = "Le numéro doit contenir uniquement des chiffres";
    } else if (expectedLengthPersonal && phoneDigits.length !== expectedLengthPersonal) {
      e.phone = `Numéro ${selectedCountryPersonal?.name || ""} invalide (${phoneDigits.length} chiffres, besoin de ${expectedLengthPersonal} chiffres)`;
    } else if (!expectedLengthPersonal && (phoneDigits.length < 8 || phoneDigits.length > 15)) {
      e.phone = `Numéro invalide (${phoneDigits.length} chiffres, doit être entre 8 et 15 chiffres)`;
    }

    if (form.profile !== "1" && !form.matricule_user.trim()) {
      e.matricule_user = "Le matricule est obligatoire pour ce profil.";
    }

    if (currentProfile === "1" && form.profile === "3") {
      const required_societe_fields = ['nom_societe', 'tel_societe', 'email_societe', 'nif_societe', 'rccm_societe'];
      required_societe_fields.forEach(field => {
        if (!societeForm[field] || !societeForm[field].toString().trim()) {
          e[field] = `Le champ ${field.replace('_', ' ')} est requis.`;
        }
      });

      // Validation téléphone société - DYNAMIQUE PAR PAYS
      const telSocieteDigits = extractPhoneDigits(societeForm.tel_societe);
      const telSocieteFullNumber = formatFullPhoneNumber(telSocieteDigits, selectedCountrySociete?.code || "+227");
      const expectedLengthSociete = selectedCountrySociete?.phoneLength;
      
      if (societeForm.tel_societe) {
        if (!/^\d+$/.test(telSocieteDigits)) {
          e.tel_societe = "Le numéro doit contenir uniquement des chiffres";
        } else if (expectedLengthSociete && telSocieteDigits.length !== expectedLengthSociete) {
          e.tel_societe = `Numéro ${selectedCountrySociete?.name || ""} invalide (${telSocieteDigits.length} chiffres, besoin de ${expectedLengthSociete} chiffres)`;
        } else if (!expectedLengthSociete && (telSocieteDigits.length < 8 || telSocieteDigits.length > 15)) {
          e.tel_societe = `Numéro invalide (${telSocieteDigits.length} chiffres, doit être entre 8 et 15 chiffres)`;
        }
      }

      if (societeForm.email_societe) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(societeForm.email_societe)) {
          e.email_societe = "Format d'email invalide pour la société. Exemple : contact@societe.com";
        }
      }

      const hasNif = files.nif && files.nif.size > 0;
      const hasRccm = files.rccm && files.rccm.size > 0;
      if (!hasNif && !hasRccm) {
        e.files = "Au moins un document (NIF ou RCCM) est obligatoire.";
      }
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError("");
    setSuccessMsg("");
    
    if (!validate()) return;
    
    setLoading(true);

    try {
      const url = `${API_BASE_URL}/users/create.php`;
      const token = localStorage.getItem("access_token");

      if (!token) {
        setServerError("Session expirée. Veuillez vous reconnecter.");
        setLoading(false);
        return;
      }

      const formData = new FormData();
      
      formData.append("nom", form.nom);
      formData.append("prenom", form.prenom);
      formData.append("email", form.email);
      
      // Formatage du téléphone avec indicatif
      const phoneDigits = extractPhoneDigits(form.phone);
      const phoneFullNumber = formatFullPhoneNumber(phoneDigits, selectedCountryPersonal?.code || "+227");
      formData.append("phone", phoneFullNumber);
      
      formData.append("profile", form.profile);
      formData.append("matricule_user", form.matricule_user || "");
      formData.append("send_email", form.send_email ? "1" : "0");
      
      if (currentProfile === "1" && form.profile === "3") {
        formData.append("create_societe", "1");
        
        Object.keys(societeForm).forEach(key => {
          // Formatage du téléphone société avec indicatif
          if (key === "tel_societe") {
            const telSocieteDigits = extractPhoneDigits(societeForm[key]);
            const telSocieteFullNumber = formatFullPhoneNumber(telSocieteDigits, selectedCountrySociete?.code || "+227");
            formData.append(`societe[${key}]`, telSocieteFullNumber);
          } else {
            formData.append(`societe[${key}]`, societeForm[key] || '');
          }
        });
        
        if (files.nif) formData.append("nif", files.nif);
        if (files.rccm) formData.append("rccm", files.rccm);
      }

      console.log("=== Données envoyées au backend ===");
      console.log("Téléphone personnel:", phoneFullNumber);
      console.log("Téléphone société:", societeForm.tel_societe ? formatFullPhoneNumber(extractPhoneDigits(societeForm.tel_societe), selectedCountrySociete?.code || "+227") : "N/A");

      const response = await axios.post(url, formData, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      });

      const data = response.data;
      console.log("Réponse backend:", data);
      
     if (data.success) {
  // Si l'email n'a pas pu être envoyé (ou n'a pas été demandé) et qu'aucun
  // mot de passe personnalisé n'a été fourni, le backend renvoie le mot de
  // passe généré : il faut le montrer clairement au gestionnaire pour qu'il
  // le communique lui-même, et NE PAS rediriger automatiquement (il n'aurait
  // pas le temps de le copier).
  if (data.generated_password) {
    setGeneratedPassword(data.generated_password);
    setSuccessMsg(
      `✅ Utilisateur créé avec succès.\n\n` +
      `⚠️ ${data.warning || "L'email n'a pas pu être envoyé."} Communiquez ce mot de passe à l'utilisateur :`
    );
  } else {
    setSuccessMsg("✅ Utilisateur créé avec succès. Redirection vers la liste...");
    setTimeout(() => {
      navigate("/users");
    }, 2000);
  }

} else {
        setServerError(data.message || "Erreur lors de la création.");
      } 
    // Remplacer la partie catch (lignes 457-537 environ) par ceci :

} catch (err) {
  console.error("Erreur complète:", err);
  
  if (err.response) {
    const { status, data } = err.response;
    console.error("Réponse erreur DÉTAILLÉE:", data);
    
    if (data.errors && Array.isArray(data.errors)) {
      console.error("=== ERREURS DE VALIDATION ===");
      data.errors.forEach((error, index) => {
        console.error(`${index + 1}. ${error}`);
      });
    }
    
    if (status === 401) {
      setServerError("Session expirée. Veuillez vous reconnecter.");
      setTimeout(() => navigate("/login"), 2000);
    } // Dans le catch, pour le cas status === 403 avec code === 'ABONNEMENT_REQUIS'

if (status === 403) {
  // 🔍 Vérifier si c'est une erreur d'abonnement
  if (data.code === 'ABONNEMENT_REQUIS') {
    // Extraire le message sans le lien
    const messageSansLien = data.message.split('\n\n')[0] + "\n\n" + 
                           "Pour pouvoir créer des utilisateurs, vous devez d'abord souscrire à un abonnement.";
    
    setServerError(
      <div>
        <div style={{ whiteSpace: 'pre-line', marginBottom: '15px' }}>
          {messageSansLien}
        </div>
        <div className="d-flex gap-2 justify-content-center">
          <a 
            href="/abonnements/create"
            className="btn fw-semibold"
            style={{
              backgroundColor: '#4caf50',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 20px',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#45a049'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#4caf50'}
          >
            <i className="bi bi-box-arrow-up-right"></i>
            Souscrire à un abonnement
          </a>
          <button
            className="btn fw-semibold"
            onClick={() => setServerError("")}
            style={{
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 20px'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#d32f2f'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#f44336'}
          >
            Fermer
          </button>
        </div>
      </div>
    );
  } else {
    setServerError(data.message || "Permission refusée.");
  }
} else if (status === 409) {
      setServerError("Cet email ou matricule est déjà utilisé.");
    } else if (status === 400) {
      if (data.errors) {
        const validationErrors = {};
        data.errors.forEach(error => {
          console.error("Erreur reçue:", error);
          
          if (error.includes("nom")) validationErrors.nom = error;
          else if (error.includes("prénom")) validationErrors.prenom = error;
          else if (error.includes("email")) validationErrors.email = error;
          else if (error.includes("profil")) validationErrors.profile = error;
          else if (error.includes("matricule")) validationErrors.matricule_user = error;
          else if (error.includes("téléphone") || error.includes("phone")) validationErrors.phone = error;
          else if (error.includes("nom_societe")) validationErrors.nom_societe = error;
          else if (error.includes("address_societe")) validationErrors.address_societe = error;
          else if (error.includes("tel_societe")) validationErrors.tel_societe = error;
          else if (error.includes("email_societe")) validationErrors.email_societe = error;
          else if (error.includes("nif_societe")) validationErrors.nif_societe = error;
          else if (error.includes("rccm_societe")) validationErrors.rccm_societe = error;
          else if (error.includes("document") || error.includes("fichier")) validationErrors.files = error;
          else {
            setServerError(prev => prev ? `${prev} ${error}` : error);
          }
        });
        setErrors(validationErrors);
        setServerError("Veuillez corriger les erreurs dans le formulaire.");
        
        console.error("Erreurs de validation mappées:", validationErrors);
      } else {
        setServerError(data?.message || `Erreur ${status}: Impossible de créer l'utilisateur.`);
      }
    } else {
      setServerError(data?.message || `Erreur ${status}: Impossible de créer l'utilisateur.`);
    }
  } else if (err.request) {
    setServerError("Serveur inaccessible. Vérifiez votre connexion.");
  } else {
    setServerError("Erreur: " + err.message);
  }
} finally {
  setLoading(false);
}
  };

  /* ====== COMPOSANT COUNTRYSELECTOR ====== */
  const CountrySelector = ({ 
    showList, setShowList, selectedCountry, setSelectedCountry, 
    search, setSearch, listRef, disabled 
  }) => {
    // Filtrer les pays de manière SÉCURISÉE
    const filteredCountries = (countryCodes || []).filter(country => {
      if (!country) return false;
      
      const searchTerm = (search || "").toLowerCase();
      const countryName = String(country.name || country.label || "").toLowerCase();
      const countryCode = String(country.code || "").toLowerCase();
      
      return countryName.includes(searchTerm) || countryCode.includes(searchTerm);
    });

    return (
      <div ref={listRef} className="position-relative">
        <button
          type="button"
          className="btn d-flex align-items-center justify-content-between"
          onClick={() => setShowList(!showList)}
          disabled={disabled}
          style={{
            backgroundColor: '#F5F7FA',
            border: `1px solid ${errors.phone || errors.tel_societe ? '#f44336' : '#e0e0e0'}`,
            borderRadius: '8px',
            padding: '8px 12px',
            width: '120px',
            minHeight: '44px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.6 : 1
          }}
        >
          <span className="me-2" style={{ fontSize: '1.2rem' }}>{selectedCountry?.flag || "🏳️"}</span>
          <span style={{ fontSize: '0.9rem', color: '#2E2E2E', fontWeight: '500' }}>
            {selectedCountry?.code || "+227"}
          </span>
          <i className="bi bi-chevron-down ms-2" style={{ fontSize: '0.8rem', color: '#666' }}></i>
        </button>

        {showList && !disabled && (
          <div style={{
            position: 'absolute', top: '100%', left: '0', width: '280px', maxHeight: '300px',
            backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 1000, overflow: 'hidden', marginTop: '4px'
          }}>
            <div className="p-2 border-bottom">
              <div className="input-group">
                <span className="input-group-text" style={{ 
                  backgroundColor: '#F5F7FA', borderColor: '#e0e0e0', padding: '8px 12px'
                }}>
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Rechercher un pays..."
                  value={search || ""}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ fontSize: '0.9rem', borderColor: '#e0e0e0', padding: '8px 12px' }}
                  autoFocus
                />
              </div>
            </div>

            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              {filteredCountries.map((country, index) => {
                if (!country) return null;
                
                return (
                  <button
                    key={index}
                    type="button"
                    className="btn btn-light text-start w-100 border-0 rounded-0"
                    onClick={() => {
                      if (country) {
                        setSelectedCountry(country);
                        setShowList(false);
                        setSearch("");
                      }
                    }}
                    style={{ 
                      padding: '10px 16px', 
                      borderBottom: '1px solid #f0f0f0', 
                      fontSize: '0.9rem',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                  >
                    <div className="d-flex align-items-center">
                      <span className="me-3" style={{ fontSize: '1.2rem', minWidth: '30px' }}>
                        {country?.flag || "🏳️"}
                      </span>
                      <div className="flex-grow-1">
                        <div style={{ fontWeight: '500' }}>
                          {country?.name || country?.label || "Pays"}
                        </div>
                        <small style={{ color: '#666' }}>{country?.code || ""}</small>
                        {country?.phoneLength && (
                          <small style={{ color: '#666', display: 'block' }}>
                            {country.phoneLength} chiffres
                          </small>
                        )}
                      </div>
                      {selectedCountry?.code === country?.code && <i className="bi bi-check text-primary"></i>}
                    </div>
                  </button>
                );
              })}
              
              {filteredCountries.length === 0 && (
                <div className="text-center py-3 text-muted" style={{ fontSize: '0.9rem' }}>
                  Aucun pays trouvé
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const showSocieteSection = currentProfile === "1" && form.profile === "3";

  return (
    <Layout>
      <div className="pagetitle">
        <h1 style={{ color: '#0B3C5D', fontWeight: '600' }}>Créer un utilisateur</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">Administration</li>
            <li className="breadcrumb-item">
              <a href="/users" onClick={(e) => { e.preventDefault(); navigate("/users"); }}>
                Utilisateurs
              </a>
            </li>
            <li className="breadcrumb-item active" style={{ color: '#1E88C8' }}>Nouveau</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              border: 'none'
            }}>
              <div className="card-body">
                <h5 className="card-title" style={{ 
                  color: '#0B3C5D',
                  borderBottom: '2px solid #F5F7FA',
                  paddingBottom: '16px',
                  marginBottom: '24px'
                }}>
                  <i className="bi bi-person-plus me-2" style={{ color: '#1E88C8' }}></i>
                  {currentProfile === "1" 
                    ? "Créer un nouvel utilisateur" 
                    : "Créer un utilisateur"}
                </h5>
                
                
                {serverError && (
                  <div className="alert alert-danger alert-dismissible fade show mb-4" style={{ 
                    backgroundColor: '#ffebee',
                    borderColor: '#f44336',
                    color: '#c62828',
                    borderRadius: '8px',
                    borderLeft: '4px solid #f44336'
                  }}>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-exclamation-triangle me-2"></i>
                      <div className="flex-grow-1">{serverError}</div>
                      <button 
                        type="button" 
                        className="btn-close" 
                        onClick={() => setServerError("")}
                      ></button>
                    </div>
                  </div>
                )}
                
                {successMsg && !generatedPassword && (
                  <div className="alert alert-success mb-4" style={{
                    backgroundColor: '#e8f5e9',
                    borderColor: '#4caf50',
                    color: '#2e7d32',
                    borderRadius: '8px',
                    borderLeft: '4px solid #4caf50',
                    whiteSpace: "pre-line"
                  }}>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-check-circle me-2" style={{ fontSize: '1.2rem' }}></i>
                      <div className="flex-grow-1">{successMsg}</div>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setSuccessMsg("")}
                      ></button>
                    </div>
                  </div>
                )}

                <form className="row g-3" onSubmit={handleSubmit}>
                  {/* BLOC : Informations personnelles */}
                  <div className="col-12">
                    <div className="d-flex align-items-center mb-3">
                      <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ 
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#E3F2FD',
                        color: '#0B3C5D'
                      }}>
                        <i className="bi bi-person-badge"></i>
                      </div>
                      <h6 style={{ color: '#0B3C5D', fontWeight: '600', marginBottom: '0' }}>
                        Informations utilisateur
                      </h6>
                    </div>
                  </div>

                  {/* Ligne 1 - Prénom, Nom, Email */}
                  <div className="col-md-4">
                    <label htmlFor="prenom" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                      <i className="bi bi-person me-1" style={{ color: '#1E88C8' }}></i>
                      Prénom <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text" style={{ 
                        backgroundColor: '#F5F7FA',
                        borderColor: errors.prenom ? '#f44336' : '#e0e0e0',
                        color: errors.prenom ? '#f44336' : '#1E88C8'
                      }}>
                        <i className="bi bi-person-vcard"></i>
                      </span>
                      <input
                        type="text"
                        id="prenom"
                        name="prenom"
                        className={`form-control ${errors.prenom ? "is-invalid" : ""}`}
                        value={form.prenom}
                        onChange={handleChange}
                        disabled={loading}
                        placeholder="Ex: Jean"
                        autoComplete="given-name"
                        style={{ 
                          borderColor: errors.prenom ? '#f44336' : '#e0e0e0',
                          borderRadius: '0 8px 8px 0',
                          color: '#2E2E2E'
                        }}
                      />
                    </div>
                    {errors.prenom && <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.prenom}</div>}
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="nom" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                      <i className="bi bi-person me-1" style={{ color: '#1E88C8' }}></i>
                      Nom <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text" style={{ 
                        backgroundColor: '#F5F7FA',
                        borderColor: errors.nom ? '#f44336' : '#e0e0e0',
                        color: errors.nom ? '#f44336' : '#1E88C8'
                      }}>
                        <i className="bi bi-person-vcard"></i>
                      </span>
                      <input
                        type="text"
                        id="nom"
                        name="nom"
                        className={`form-control ${errors.nom ? "is-invalid" : ""}`}
                        value={form.nom}
                        onChange={handleChange}
                        disabled={loading}
                        placeholder="Ex: Dupont"
                        autoComplete="family-name"
                        style={{ 
                          borderColor: errors.nom ? '#f44336' : '#e0e0e0',
                          borderRadius: '0 8px 8px 0',
                          color: '#2E2E2E'
                        }}
                      />
                    </div>
                    {errors.nom && <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.nom}</div>}
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="email" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                      <i className="bi bi-envelope me-1" style={{ color: '#1E88C8' }}></i>
                      Email <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text" style={{ 
                        backgroundColor: '#F5F7FA',
                        borderColor: errors.email ? '#f44336' : '#e0e0e0',
                        color: errors.email ? '#f44336' : '#1E88C8'
                      }}>
                        <i className="bi bi-at"></i>
                      </span>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        value={form.email}
                        onChange={handleChange}
                        disabled={loading}
                        placeholder="prenomnom@domaine.com"
                        autoComplete="email"
                        style={{ 
                          borderColor: errors.email ? '#f44336' : '#e0e0e0',
                          borderRadius: '0 8px 8px 0',
                          color: '#2E2E2E'
                        }}
                      />
                    </div>
                    {errors.email && <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.email}</div>}
                  </div>

                  {/* Ligne 2 - Téléphone avec indicateur */}
                  <div className="col-md-4">
                    <label htmlFor="phone" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                      <i className="bi bi-phone me-1" style={{ color: '#1E88C8' }}></i>
                      Téléphone <span className="text-danger">*</span>
                    </label>
                    
                    <div className="d-flex align-items-stretch" style={{ gap: '8px' }}>
                      <CountrySelector
                        showList={showCountryListPersonal}
                        setShowList={setShowCountryListPersonal}
                        selectedCountry={selectedCountryPersonal}
                        setSelectedCountry={setSelectedCountryPersonal}
                        search={searchCountryPersonal}
                        setSearch={setSearchCountryPersonal}
                        listRef={countryListRefPersonal}
                        disabled={loading}
                      />
                      
                      <div className="position-relative" style={{ flex: '1' }}>
                        <div style={{
                          position: 'absolute',
                          left: '12px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          color: '#666',
                          fontSize: '0.95rem',
                          pointerEvents: 'none',
                          zIndex: 5
                        }}>
                          {selectedCountryPersonal?.code || "+227"}
                        </div>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                          value={form.phone}
                          onChange={handleChange}
                          placeholder={selectedCountryPersonal?.phoneLength ? 
                            `Ex: ${generatePhoneExample(selectedCountryPersonal.phoneLength)}` : 
                            "Numéro de téléphone"}
                          disabled={loading}
                          maxLength={selectedCountryPersonal?.phoneLength || 15}
                          inputMode="numeric"
                          pattern="[0-9]*"
                          style={{ 
                            borderRadius: '8px',
                            borderColor: errors.phone ? '#f44336' : '#e0e0e0',
                            padding: '12px 16px 12px 55px',
                            fontSize: '0.95rem',
                            width: '100%',
                            color: '#2E2E2E'
                          }}
                        />
                      </div>
                    </div>
                    
                    {errors.phone && (
                      <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>
                        {errors.phone}
                      </div>
                    )}
                    
                    <small className="text-muted" style={{ fontSize: '0.8rem', marginTop: '4px', display: 'block' }}>
                      Format: {selectedCountryPersonal?.code || "+227"} + {selectedCountryPersonal?.phoneLength || "?"} chiffres
                      {selectedCountryPersonal?.phoneLength && 
                        ` (ex: ${selectedCountryPersonal.code}${generatePhoneExample(selectedCountryPersonal.phoneLength)})`}
                    </small>
                  </div>

                  {/* Ligne 2 - Profil, Matricule */}
                  <div className="col-md-4">
                    <label htmlFor="profile" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                      <i className="bi bi-person-badge me-1" style={{ color: '#1E88C8' }}></i>
                      Profil <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text" style={{ 
                        backgroundColor: '#F5F7FA',
                        borderColor: errors.profile ? '#f44336' : '#e0e0e0',
                        color: errors.profile ? '#f44336' : '#1E88C8'
                      }}>
                        <i className="bi bi-people"></i>
                      </span>
                      {currentProfile === "3" ? (
                        <select
                          id="profile"
                          name="profile"
                          className={`form-control ${errors.profile ? "is-invalid" : ""}`}
                          value={form.profile}
                          onChange={handleChange}
                          disabled={loading}
                          required
                          autoComplete="off"
                          style={{ 
                            borderColor: errors.profile ? '#f44336' : '#e0e0e0',
                            borderRadius: '0 8px 8px 0',
                            color: '#2E2E2E'
                          }}
                        >
                          <option value="">Sélectionner un profil</option>
                          <option value="2">Contrôleur</option>
                          <option value="4">Agent</option>
                          <option value="5">Poste de contrôle</option>
                        </select>
                      ) : currentProfile === "1" ? (
                        <select
                          id="profile"
                          name="profile"
                          className={`form-control ${errors.profile ? "is-invalid" : ""}`}
                          value={form.profile}
                          onChange={handleChange}
                          disabled={loading}
                          required
                          autoComplete="off"
                          style={{ 
                            borderColor: errors.profile ? '#f44336' : '#e0e0e0',
                            borderRadius: '0 8px 8px 0',
                            color: '#2E2E2E'
                          }}
                        >
                          <option value="">Sélectionner un profil</option>
                          <option value="1">Administrateur</option>
                          <option value="3">Gestionnaire</option>
                        </select>
                      ) : null}
                    </div>
                    {errors.profile && (
                      <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.profile}</div>
                    )}
                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.85rem' }}>
                      <i className="bi bi-info-circle me-1"></i>
                      {form.profile === "2"
                        ? "Le contrôleur travaillera dans votre société"
                        : form.profile === "4"
                        ? "L'agent sera affecté à votre société"
                        : form.profile === "5"
                        ? "Le poste de contrôle supervisera votre société"
                        : form.profile === "3"
                        ? "Nécessite création société"
                        : form.profile === "1"
                        ? "Sans société"
                        : "Sélectionnez un profil"}
                    </small>
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="matricule_user" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                      <i className="bi bi-card-text me-1" style={{ color: '#1E88C8' }}></i>
                      Matricule {form.profile !== "1" && form.profile !== "" && <span className="text-danger">*</span>}
                    </label>
                    <div className="input-group">
                      <span className="input-group-text" style={{ 
                        backgroundColor: '#F5F7FA',
                        borderColor: errors.matricule_user ? '#f44336' : '#e0e0e0',
                        color: errors.matricule_user ? '#f44336' : '#1E88C8'
                      }}>
                        <i className="bi bi-123"></i>
                      </span>
                      <input
                        type="text"
                        id="matricule_user"
                        name="matricule_user"
                        className={`form-control ${errors.matricule_user ? "is-invalid" : ""}`}
                        value={form.matricule_user}
                        onChange={handleChange}
                        disabled={loading || form.profile === "1"}
                        placeholder={form.profile === "1" ? "Optionnel" :
                                   form.profile === "4" ? "Ex: AGNT1234" :
                                   form.profile === "5" ? "Ex: PC1234" : "Ex: CTRL1234"}
                        autoComplete="off"
                        style={{ 
                          borderColor: errors.matricule_user ? '#f44336' : '#e0e0e0',
                          borderRadius: '0 8px 8px 0',
                          color: '#2E2E2E'
                        }}
                      />
                    </div>
                    {errors.matricule_user && (
                      <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.matricule_user}</div>
                    )}
                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.85rem' }}>
                      {form.profile === "1" || !form.profile
                        ? "Optionnel" 
                        : "Obligatoire - Format libre selon le système de l'entreprise"}
                    </small>
                  </div>

                  {/* Ligne 3 - Options seulement */}
                  <div className="col-md-6">
                    <div className="card mb-3" style={{ 
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px'
                    }}>
                      <div className="card-body p-3">
                        <label className="form-label d-flex align-items-center" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                          <i className="bi bi-shield-lock me-2" style={{ color: '#1E88C8' }}></i>
                          Options de sécurité
                        </label>
                        <div className="form-check mt-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="send_email"
                            id="send_email"
                            checked={form.send_email}
                            onChange={handleChange}
                            disabled={loading}
                            style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
                          />
                          <label className="form-check-label" htmlFor="send_email" style={{ cursor: loading ? 'not-allowed' : 'pointer' }}>
                            <i className="bi bi-envelope-check me-1"></i>
                            Envoyer le mot de passe temporaire par email
                          </label>
                        </div>
                        <small className="text-muted d-block mt-2" style={{ fontSize: '0.85rem' }}>
                          Un mot de passe sécurisé sera généré automatiquement et envoyé à l'utilisateur.
                          {!form.send_email && (
                            <span className="d-block mt-1" style={{ color: '#ff9800' }}>
                              <i className="bi bi-exclamation-triangle me-1"></i>
                              Vous devrez communiquer manuellement le mot de passe à l'utilisateur.
                            </span>
                          )}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card" style={{ 
                      border: '2px solid #4FC3F7',
                      borderRadius: '8px',
                      backgroundColor: '#E3F2FD'
                    }}>
                      <div className="card-body p-3">
                        <small>
                          <i className="bi bi-shield-check me-1" style={{ color: '#0B3C5D' }}></i>
                          <strong style={{ color: '#0B3C5D' }}>Procédure de sécurité :</strong>
                          <ul className="mb-0 mt-1" style={{ color: '#2E2E2E' }}>
                            <li>✅ Mot de passe généré automatiquement</li>
                            <li>✅ Envoi sécurisé par email</li>
                            <li>✅ L'utilisateur doit le changer à la première connexion</li>
                          </ul>
                        </small>
                      </div>
                    </div>
                  </div>

                  {/* SECTION SOCIÉTÉ (uniquement pour admin créant gestionnaire) */}
                  {showSocieteSection && (
                    <>
                      <div className="col-12 mt-5">
                        <div className="d-flex align-items-center mb-3">
                          <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ 
                            width: '40px',
                            height: '40px',
                            backgroundColor: '#E3F2FD',
                            color: '#0B3C5D'
                          }}>
                            <i className="bi bi-building"></i>
                          </div>
                          <h6 style={{ color: '#0B3C5D', fontWeight: '600', marginBottom: '0' }}>
                            Informations de la société
                          </h6>
                        </div>
                      </div>

                      {/* Ligne 1 - Nom société, Adresse (optionnelle) */}
                      <div className="col-md-6">
                        <label htmlFor="nom_societe" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                          <i className="bi bi-building me-1" style={{ color: '#1E88C8' }}></i>
                          Nom de la société <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <span className="input-group-text" style={{ 
                            backgroundColor: '#F5F7FA',
                            borderColor: errors.nom_societe ? '#f44336' : '#e0e0e0',
                            color: errors.nom_societe ? '#f44336' : '#1E88C8'
                          }}>
                            <i className="bi bi-building"></i>
                          </span>
                          <input
                            type="text"
                            id="nom_societe"
                            name="nom_societe"
                            className={`form-control ${errors.nom_societe ? "is-invalid" : ""}`}
                            value={societeForm.nom_societe}
                            onChange={handleSocieteChange}
                            disabled={loading}
                            placeholder="Ex: Entreprise SARL"
                            autoComplete="organization"
                            style={{ 
                              borderColor: errors.nom_societe ? '#f44336' : '#e0e0e0',
                              borderRadius: '0 8px 8px 0',
                              color: '#2E2E2E'
                            }}
                          />
                        </div>
                        {errors.nom_societe && (
                          <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.nom_societe}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="address_societe" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                          <i className="bi bi-geo-alt me-1" style={{ color: '#1E88C8' }}></i>
                          Adresse <span className="text-muted">(Optionnel)</span>
                        </label>
                        <div className="input-group">
                          <span className="input-group-text" style={{ 
                            backgroundColor: '#F5F7FA',
                            borderColor: errors.address_societe ? '#f44336' : '#e0e0e0',
                            color: errors.address_societe ? '#f44336' : '#1E88C8'
                          }}>
                            <i className="bi bi-geo-alt"></i>
                          </span>
                          <input
                            type="text"
                            id="address_societe"
                            name="address_societe"
                            className={`form-control ${errors.address_societe ? "is-invalid" : ""}`}
                            value={societeForm.address_societe}
                            onChange={handleSocieteChange}
                            disabled={loading}
                            placeholder="Adresse complète"
                            autoComplete="street-address"
                            style={{ 
                              borderColor: errors.address_societe ? '#f44336' : '#e0e0e0',
                              borderRadius: '0 8px 8px 0',
                              color: '#2E2E2E'
                            }}
                          />
                        </div>
                        {errors.address_societe && (
                          <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.address_societe}</div>
                        )}
                      </div>

                      {/* Ligne 2 - Téléphone société avec indicateur */}
                      <div className="col-md-6">
                        <label htmlFor="tel_societe" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                          <i className="bi bi-phone me-1" style={{ color: '#1E88C8' }}></i>
                          Téléphone société <span className="text-danger">*</span>
                        </label>
                        
                        <div className="d-flex align-items-stretch" style={{ gap: '8px' }}>
                          <CountrySelector
                            showList={showCountryListSociete}
                            setShowList={setShowCountryListSociete}
                            selectedCountry={selectedCountrySociete}
                            setSelectedCountry={setSelectedCountrySociete}
                            search={searchCountrySociete}
                            setSearch={setSearchCountrySociete}
                            listRef={countryListRefSociete}
                            disabled={loading}
                          />
                          
                          <div className="position-relative" style={{ flex: '1' }}>
                            <div style={{
                              position: 'absolute',
                              left: '12px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              color: '#666',
                              fontSize: '0.95rem',
                              pointerEvents: 'none',
                              zIndex: 5
                            }}>
                              {selectedCountrySociete?.code || "+227"}
                            </div>
                            <input
                              type="tel"
                              id="tel_societe"
                              name="tel_societe"
                              className={`form-control ${errors.tel_societe ? 'is-invalid' : ''}`}
                              value={societeForm.tel_societe}
                              onChange={handleSocieteChange}
                              placeholder={selectedCountrySociete?.phoneLength ? 
                                `Ex: ${generatePhoneExample(selectedCountrySociete.phoneLength)}` : 
                                "Numéro de téléphone"}
                              disabled={loading}
                              maxLength={selectedCountrySociete?.phoneLength || 15}
                              inputMode="numeric"
                              pattern="[0-9]*"
                              style={{ 
                                borderRadius: '8px',
                                borderColor: errors.tel_societe ? '#f44336' : '#e0e0e0',
                                padding: '12px 16px 12px 55px',
                                fontSize: '0.95rem',
                                width: '100%',
                                color: '#2E2E2E'
                              }}
                            />
                          </div>
                        </div>
                        
                        {errors.tel_societe && (
                          <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>
                            {errors.tel_societe}
                          </div>
                        )}
                        
                        <small className="text-muted" style={{ fontSize: '0.8rem', marginTop: '4px', display: 'block' }}>
                          Format: {selectedCountrySociete?.code || "+227"} + {selectedCountrySociete?.phoneLength || "?"} chiffres
                          {selectedCountrySociete?.phoneLength && 
                            ` (ex: ${selectedCountrySociete.code}${generatePhoneExample(selectedCountrySociete.phoneLength)})`}
                        </small>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="email_societe" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                          <i className="bi bi-envelope me-1" style={{ color: '#1E88C8' }}></i>
                          Email société <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <span className="input-group-text" style={{ 
                            backgroundColor: '#F5F7FA',
                            borderColor: errors.email_societe ? '#f44336' : '#e0e0e0',
                            color: errors.email_societe ? '#f44336' : '#1E88C8'
                          }}>
                            <i className="bi bi-at"></i>
                          </span>
                          <input
                            type="email"
                            id="email_societe"
                            name="email_societe"
                            className={`form-control ${errors.email_societe ? "is-invalid" : ""}`}
                            value={societeForm.email_societe}
                            onChange={handleSocieteChange}
                            disabled={loading}
                            placeholder="contact@entreprise.com"
                            autoComplete="email"
                            style={{ 
                              borderColor: errors.email_societe ? '#f44336' : '#e0e0e0',
                              borderRadius: '0 8px 8px 0',
                              color: '#2E2E2E'
                            }}
                          />
                        </div>
                        {errors.email_societe && (
                          <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.email_societe}</div>
                        )}
                        <small className="text-muted d-block mt-1" style={{ fontSize: '0.85rem' }}>Format accepté : contact@societe.com</small>
                      </div>

                      {/* Ligne 3 - NIF, RCCM, Code postal (optionnel) */}
                      <div className="col-md-4">
                        <label htmlFor="nif_societe" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                          <i className="bi bi-file-text me-1" style={{ color: '#1E88C8' }}></i>
                          NIF <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <span className="input-group-text" style={{ 
                            backgroundColor: '#F5F7FA',
                            borderColor: errors.nif_societe ? '#f44336' : '#e0e0e0',
                            color: errors.nif_societe ? '#f44336' : '#1E88C8'
                          }}>
                            <i className="bi bi-file-earmark-text"></i>
                          </span>
                          <input
                            type="text"
                            id="nif_societe"
                            name="nif_societe"
                            className={`form-control ${errors.nif_societe ? "is-invalid" : ""}`}
                            value={societeForm.nif_societe}
                            onChange={handleSocieteChange}
                            disabled={loading}
                            placeholder="N° identification fiscale"
                            autoComplete="off"
                            style={{ 
                              borderColor: errors.nif_societe ? '#f44336' : '#e0e0e0',
                              borderRadius: '0 8px 8px 0',
                              color: '#2E2E2E'
                            }}
                          />
                        </div>
                        {errors.nif_societe && (
                          <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.nif_societe}</div>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="rccm_societe" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                          <i className="bi bi-file-text me-1" style={{ color: '#1E88C8' }}></i>
                          RCCM <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <span className="input-group-text" style={{ 
                            backgroundColor: '#F5F7FA',
                            borderColor: errors.rccm_societe ? '#f44336' : '#e0e0e0',
                            color: errors.rccm_societe ? '#f44336' : '#1E88C8'
                          }}>
                            <i className="bi bi-file-earmark-text"></i>
                          </span>
                          <input
                            type="text"
                            id="rccm_societe"
                            name="rccm_societe"
                            className={`form-control ${errors.rccm_societe ? "is-invalid" : ""}`}
                            value={societeForm.rccm_societe}
                            onChange={handleSocieteChange}
                            disabled={loading}
                            placeholder="Registre du commerce"
                            autoComplete="off"
                            style={{ 
                              borderColor: errors.rccm_societe ? '#f44336' : '#e0e0e0',
                              borderRadius: '0 8px 8px 0',
                              color: '#2E2E2E'
                            }}
                          />
                        </div>
                        {errors.rccm_societe && (
                          <div className="invalid-feedback d-block mt-2" style={{ fontSize: '0.85rem' }}>{errors.rccm_societe}</div>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="code_postal_societe" className="form-label" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                          <i className="bi bi-mailbox me-1" style={{ color: '#1E88C8' }}></i>
                          Code postal <span className="text-muted">(Optionnel)</span>
                        </label>
                        <div className="input-group">
                          <span className="input-group-text" style={{ 
                            backgroundColor: '#F5F7FA',
                            borderColor: '#e0e0e0',
                            color: '#1E88C8'
                          }}>
                            <i className="bi bi-mailbox"></i>
                          </span>
                          <input
                            type="text"
                            id="code_postal_societe"
                            name="code_postal_societe"
                            className="form-control"
                            value={societeForm.code_postal_societe}
                            onChange={handleSocieteChange}
                            disabled={loading}
                            placeholder="Optionnel"
                            autoComplete="postal-code"
                            style={{ 
                              borderColor: '#e0e0e0',
                              borderRadius: '0 8px 8px 0',
                              color: '#2E2E2E'
                            }}
                          />
                        </div>
                      </div>

                      {/* Ligne 4 - Fichiers */}
                      <div className="col-12">
                        <div className="card mt-3" style={{ 
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          backgroundColor: '#F5F7FA'
                        }}>
                          <div className="card-body">
                            <label className="form-label d-flex align-items-center" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                              <i className="bi bi-files me-2" style={{ color: '#1E88C8' }}></i>
                              Documents de la société <span className="text-danger ms-1">*</span>
                            </label>
                            <small className="text-muted mb-3 d-block" style={{ fontSize: '0.85rem' }}>(Au moins un document requis - NIF ou RCCM)</small>
                            
                            <div className="row">
                              <div className="col-md-6">
                                <div className="card mb-3" style={{ borderRadius: '8px' }}>
                                  <div className="card-body">
                                    <label htmlFor="nif" className="form-label small" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                                      NIF (PDF/Image - max 5MB)
                                    </label>
                                    <input
                                      type="file"
                                      id="nif"
                                      name="nif"
                                      className={`form-control ${errors.files ? 'is-invalid' : ''}`}
                                      onChange={handleFileChange}
                                      disabled={loading}
                                      accept=".pdf,.jpg,.jpeg,.png"
                                      style={{ 
                                        borderColor: errors.files ? '#f44336' : '#e0e0e0',
                                        borderRadius: '8px'
                                      }}
                                    />
                                    {files.nif && (
                                      <small className="text-success d-block mt-2">
                                        <i className="bi bi-check-circle me-1"></i>
                                        {files.nif.name}
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="card mb-3" style={{ borderRadius: '8px' }}>
                                  <div className="card-body">
                                    <label htmlFor="rccm" className="form-label small" style={{ color: '#2E2E2E', fontWeight: '500' }}>
                                      RCCM (PDF/Image - max 5MB)
                                    </label>
                                    <input
                                      type="file"
                                      id="rccm"
                                      name="rccm"
                                      className={`form-control ${errors.files ? 'is-invalid' : ''}`}
                                      onChange={handleFileChange}
                                      disabled={loading}
                                      accept=".pdf,.jpg,.jpeg,.png"
                                      style={{ 
                                        borderColor: errors.files ? '#f44336' : '#e0e0e0',
                                        borderRadius: '8px'
                                      }}
                                    />
                                    {files.rccm && (
                                      <small className="text-success d-block mt-2">
                                        <i className="bi bi-check-circle me-1"></i>
                                        {files.rccm.name}
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {errors.files && (
                              <div className="alert alert-warning mt-2 mb-0" style={{ 
                                backgroundColor: '#fff8e1',
                                borderColor: '#ffc107',
                                color: '#ff8f00',
                                borderRadius: '8px',
                                fontSize: '0.85rem'
                              }}>
                                <i className="bi bi-exclamation-triangle me-1"></i>
                                {errors.files}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Boutons */}
                  <div className="col-12 d-flex justify-content-between mt-4 pt-4 border-top" style={{ borderColor: '#F5F7FA' }}>
                    <button 
                      type="submit" 
                      className="btn fw-semibold"
                      disabled={loading}
                      style={{
                        color: 'white',
                        backgroundColor: loading ? '#B0BEC5' : '#0B3C5D',
                        borderColor: loading ? '#B0BEC5' : '#0B3C5D',
                        borderRadius: '8px',
                        padding: '12px 32px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        opacity: loading ? 0.8 : 1
                      }}
                      onMouseEnter={(e) => {
                        if (!loading) {
                          e.target.style.backgroundColor = '#1E88C8';
                          e.target.style.borderColor = '#1E88C8';
                          e.target.style.transform = 'translateY(-2px)';
                          e.target.style.boxShadow = '0 6px 12px rgba(11, 60, 93, 0.2)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!loading) {
                          e.target.style.backgroundColor = '#0B3C5D';
                          e.target.style.borderColor = '#0B3C5D';
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = 'none';
                        }
                      }}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Création en cours...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-plus-circle me-2"></i>
                          Créer l'utilisateur
                        </>
                      )}
                    </button>
                    
                    <button
                      type="button"
                      className="btn fw-semibold"
                      onClick={() => navigate("/users")}
                      disabled={loading}
                      style={{
                        color: '#2E2E2E',
                        borderColor: '#e0e0e0',
                        backgroundColor: 'transparent',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#F5F7FA';
                        e.target.style.borderColor = '#0B3C5D';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.borderColor = '#e0e0e0';
                      }}
                    >
                      <i className="bi bi-x-circle me-2"></i>
                      Annuler
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Styles CSS additionnels */}
      <style>{`
        .pagetitle h1,
        .card-title,
        .btn,
        .form-label,
        .alert strong {
          font-family: 'Inter', sans-serif;
        }
        
        .card-body,
        .form-control,
        .form-select,
        .form-text,
        .alert,
        .table,
        small {
          font-family: 'Roboto', sans-serif;
        }
        
        .form-control:focus,
        .form-select:focus {
          border-color: #1E88C8;
          box-shadow: 0 0 0 0.2rem rgba(30, 136, 200, 0.25);
        }
        
        .btn:focus {
          outline: none;
          box-shadow: 0 0 0 0.2rem rgba(11, 60, 93, 0.25);
        }
        
        .btn,
        .form-select,
        .input-group-text,
        .form-control {
          transition: all 0.2s ease-in-out;
        }
        
        .btn:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
        
        .form-control:disabled,
        .form-select:disabled {
          background-color: '#F5F7FA';
          cursor: not-allowed;
        }
        
        @media (max-width: 768px) {
          .card {
            margin: 0 -16px;
            border-radius: 0 !important;
          }
          
          .pagetitle h1 {
            font-size: 1.5rem;
          }
          
          .d-flex.justify-content-between {
            flex-direction: column;
            gap: 16px;
          }
          
          .d-flex.justify-content-between > div {
            width: 100%;
          }
          
          .btn {
            width: 100%;
            margin-bottom: 8px;
          }
        }
      `}</style>

      {/* Mot de passe généré — toujours dans une modale bloquante, jamais
          affiché en pleine page : évite qu'il reste visible hors écran (en
          bas d'un long formulaire) sans que le gestionnaire s'en rende compte
          avant de quitter la page. */}
      {generatedPassword && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          role="dialog"
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: '12px' }}>
              <div className="modal-header" style={{
                backgroundColor: '#e8f5e9',
                borderBottom: '1px solid #4caf50',
                borderRadius: '12px 12px 0 0'
              }}>
                <h5 className="modal-title" style={{ color: '#2e7d32', fontWeight: '600' }}>
                  <i className="bi bi-check-circle me-2"></i>
                  Utilisateur créé avec succès
                </h5>
              </div>
              <div className="modal-body">
                <p style={{ color: '#2E2E2E' }}>
                  {successMsg.replace(/^✅[^\n]*\n*/,'').replace(/^⚠️\s*/,'') || "L'email n'a pas pu être envoyé. Communiquez ce mot de passe à l'utilisateur :"}
                </p>
                <div className="d-flex align-items-center p-2" style={{
                  backgroundColor: '#F5F7FA',
                  borderRadius: '8px',
                  border: '1px dashed #4caf50'
                }}>
                  <code style={{ fontSize: '1.1rem', fontWeight: '700', color: '#2E2E2E', flexGrow: 1, letterSpacing: '0.05em' }}>
                    {passwordMasque ? '•'.repeat(Math.max(generatedPassword.length, 8)) : generatedPassword}
                  </code>
                  <button
                    type="button"
                    className="btn btn-sm fw-semibold me-2"
                    style={{ backgroundColor: 'transparent', border: '1px solid #6c757d', color: '#6c757d', borderRadius: '6px' }}
                    onClick={() => setPasswordMasque(!passwordMasque)}
                    title={passwordMasque ? 'Afficher' : 'Masquer'}
                  >
                    <i className={`bi ${passwordMasque ? 'bi-eye' : 'bi-eye-slash'}`}></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm fw-semibold"
                    style={{ backgroundColor: '#4caf50', color: 'white', borderRadius: '6px' }}
                    onClick={() => {
                      navigator.clipboard?.writeText(generatedPassword);
                      setPasswordCopie(true);
                      setTimeout(() => setPasswordCopie(false), 2000);
                    }}
                  >
                    <i className={`bi ${passwordCopie ? 'bi-check-lg' : 'bi-clipboard'} me-1`}></i>
                    {passwordCopie ? 'Copié' : 'Copier'}
                  </button>
                </div>
                <p className="form-text mt-2" style={{ fontSize: '0.85rem', color: '#6c757d' }}>
                  <i className="bi bi-info-circle me-1"></i>
                  Ce mot de passe ne sera plus affiché après fermeture de cette fenêtre.
                </p>
              </div>
              <div className="modal-footer" style={{ borderTop: '1px solid #F5F7FA' }}>
                <button
                  type="button"
                  className="btn fw-semibold"
                  style={{ backgroundColor: '#0B3C5D', color: 'white', borderRadius: '8px' }}
                  onClick={() => {
                    setGeneratedPassword("");
                    setSuccessMsg("");
                    navigate("/users");
                  }}
                >
                  <i className="bi bi-list-ul me-1"></i>
                  J'ai noté le mot de passe — Aller à la liste
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default UserCreate;